<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

const body = document.getElementsByTagName("body")[0];
const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});
onBeforeMount(() => {
  store.state.imageLayout = "profile-overview";
  store.state.showSidenav = false;
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
  if (localStorage.getItem("token")) {
    store.state.showSidenav = true;
    status = true;
  }
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});
</script>
<template>
  <main>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0" v-text="Registro"></p>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm" v-if="product.id>0">
                Actualiza la Informacion de Producto
              </p>
              <p class="text-uppercase text-sm" v-else>
                Alta de Producto
              </p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label" v-if="product.id>0"
                    >Producto: {{ product.id }}</label
                  >
                </div>

                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >CodeBar</label
                  >
                  <argon-input type="text" v-model="product.codeBar" />
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre</label
                  >
                  <input
                    class="form-control"
                    type="text"
                    v-model="product.nombre"
                  />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Descripcion</label
                  >
                  <argon-input v-model="product.descripcion" />
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">
                Information de Cantidades y Stock
              </p>
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Cantidad Actual</label
                  >
                  {{ product.cantidad }}
                </div>

                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Minimo de Stock</label
                  >
                  <argon-input type="number" v-model="product.minStock" />
                </div>

                <div class="col-md-12" v-if="product.id">
                  <label for="example-text-input" class="form-control-label"
                    >Status</label
                  >
                  <argon-switch
                    :value="product.status"
                    @change="product.status = $event.target.checked"
                  >
                    Activo
                  </argon-switch>
                </div>

                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Fecha de Creacion:
                  </label>
                  <label>{{ product.fechaCreacion }}</label>
                </div>
                <argon-button  v-if="product.id>0"
                  class="mt-4"
                  variant="gradient"
                  color="info"
                  fullWidth
                  size="sm"
                  @click.prevent="saveData"
                  >Actualizar</argon-button
                >
                <argon-button v-else
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  fullWidth
                  size="sm"
                  @click.prevent="alta" 
                  >Dar Alta</argon-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4" v-show="status">
          <profile-card />
        </div> -->
      </div>
    </div>
  </main>
</template>
<script>
import usuario from "../api/usuario";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
// import ArgonRadio from "@/components/ArgonRadio.vue";
import Swal from "sweetalert2";
import productos from "../api/productos";
export default {
  components: {
    ArgonInput,
    ArgonSwitch,
    
  },
  props: {
    product: {
      type: Object,
      required: true,
      id: {
        type: Number,
        required: true,
      },
      codeBar: {
        type: Number,
        required: true,
      },
      nombre: {
        type: String,
        required: true,
      },
      descripcion: {
        type: String,
        required: true,
      },
      cantidad: {
        type: Number,
        required: true,
      },
      minStock: {
        type: String,
        required: true,
      },
      status: {
        type: Boolean,
        required: true,
      },
      fechaCreacion: {
        type: String,
        required: true,
      },
    },
  },
  data() {
    return {
      status: null,
      model: {
          cantidad:null,
          codeBar:null,
          descripcion:null,
          fechaCreacion:null,
          id:null,
          minStock:null,
          nombre:null,
          status:null,
          token:null
      }
    };
  },
  created() {
    
  },
  methods: {
    async saveData() {
      this.loaddata();
      productos
        .update(this.model)
        .then((result) => {
          if (result.data.message != null) {
            Swal.fire({
              title: "Actualizacion Correcta",
              text: result.data.message,
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            this.$router.push({ path: "/productos" });
          } else {
            Swal.fire({
              title: "Error al Actualizar Producto",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async alta() {
      this.loaddata();
      productos
        .alta(this.model)
        .then((result) => {
          if (result.data.message != null) {
            Swal.fire({
              title: "Alta Correcta",
              text: result.data.message,
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            this.$router.push({ path: "/productos" });
          } else {
            Swal.fire({
              title: "Error al Actualizar Producto",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateData() {
      this.model.token = localStorage.getItem("token");
      usuario
        .update(this.model)
        .then((result) => {
          if (result.data.message != null) {
            Swal.fire({
              title: "Actualizacion Correcta",
              text: result.data.message,
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            this.model = null;
            this.$router.push({ path: "/usuarios" });
          } else {
            Swal.fire({
              title: "Error al actualizar",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loaddata(){
      this.model.cantidad=this.product.cantidad
      this.model.codeBar = this.product.codeBar
      this.model.descripcion= this.product.descripcion
      this.model.fechaCreacion = this.product.fechaCreacion
      this.model.id=this.product.id
      this.model.minStock=this.product.minStock
      this.model.nombre=this.product.nombre
      this.model.status=this.product.status
      this.model.token = localStorage.getItem("token")
    }
  },
};
</script>
